module.exports = __webpack_public_path__ + "static/img/02-人大附中石景山学校1.e1f10cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/02-人大附中石景山学校1.png
// module id = MzxZ
// module chunks = 0